var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUploadCsv = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.75 13.0001C3.33579 13.0001 3 13.3359 3 13.7501C3 14.1643 3.33579 14.5001 3.75 14.5001H12.25C12.6642 14.5001 13 14.1643 13 13.7501C13 13.3359 12.6642 13.0001 12.25 13.0001H3.75Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.46967 1.21967C7.76256 0.926769 8.23744 0.926769 8.53033 1.21967L12.2803 4.96964C12.5732 5.26253 12.5732 5.73741 12.2803 6.0303C11.9874 6.32319 11.5126 6.32319 11.2197 6.0303L8.75 3.56063V10.25C8.75 10.6642 8.41421 11 8 11C7.58579 11 7.25 10.6642 7.25 10.25V3.56063L4.78033 6.0303C4.48744 6.32319 4.01256 6.32319 3.71967 6.0303C3.42678 5.73741 3.42678 5.26253 3.71967 4.96964L7.46967 1.21967Z",
  fill: "white"
})));
export { SvgUploadCsv as ReactComponent };
export default __webpack_public_path__ + "0cab58a1c3a891b1ff6ce041551d651f.svg";